import { createRouter, createWebHistory } from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ '../components/Home_Page.vue')
const Blog = () => import(/* webpackChunkName: "blog" */ '../components/Blog_Page.vue')
const BlogPost = () => import(/* webpackChunkName: "blog-post" */ '../components/Blog_Post.vue')
const Demo = () => import(/* webpackChunkName: "demo" */ '../components/Demo_Page.vue')

const anchorRedirects = {
  '/home': '',
  '/about': '#about',
  '/projects': '#work',
  '/experience': '#experience',
  '/contact': '#contact'
}

const retiredRoutes = ['/reviews']

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/blog',
    name: 'Blog',
    component: Blog
  },
  {
    path: '/blog/:slug',
    name: 'BlogPost',
    component: BlogPost
  },
  {
    path: '/demo',
    name: 'DemoLibrary',
    component: Demo
  },
  {
    path: '/demo/:slug',
    name: 'Demo',
    component: Demo
  },
  ...Object.entries(anchorRedirects).map(([path, hash]) => ({
    path,
    redirect: { path: '/', hash }
  })),
  ...retiredRoutes.map((path) => ({
    path,
    redirect: '/'
  })),
  {
    path: '/:pathMatch(.*)*',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return false
    }

    return { top: 0 }
  }
})

const alignHashTarget = (hash) => {
  if (!hash) {
    return
  }

  const scrollToTarget = () => {
    // Look up an ID directly so capture fragments and malformed selectors are harmless.
    const target = document.getElementById(hash.slice(1))

    if (!target) {
      return
    }

    const top = target.getBoundingClientRect().top + window.scrollY

    window.scrollTo({
      top,
      behavior: 'auto'
    })
  }

  window.requestAnimationFrame(scrollToTarget)
  window.setTimeout(scrollToTarget, 150)
  window.setTimeout(scrollToTarget, 450)
  window.setTimeout(scrollToTarget, 900)
}

router.beforeEach((to, from, next) => {
  document.title = to.meta?.title || 'Daniel Watson | Product Designer and Developer'
  next()
})

router.afterEach((to) => {
  alignHashTarget(to.hash)
})

export default router
